'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = range;

var _list2 = require('./_list');

var _list3 = _interopRequireDefault(_list2);

var _total2 = require('./_total');

var _total3 = _interopRequireDefault(_total2);

var _entries3 = require('./_entries');

var _entries4 = _interopRequireDefault(_entries3);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

var _constants = require('../constants');

var _isError = require('../status/is-error');

var _isError2 = _interopRequireDefault(_isError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function range(root, listName, start, end) {
    // Handle empty lists
    var list = (0, _list3.default)(root, listName);
    if ((0, _total3.default)(list) < 1) {
        var _entries2 = [];
        _entries2[_constants.ENTRY] = list;
        return _entries2;
    }

    var entries = (0, _entries4.default)(root, listName, start, end);
    var result = entries.map(function (entry) {
        if (entry && (0, _isError2.default)(entry)) return entry.error;

        return (0, _resource2.default)(root, entry && entry.id);
    });

    result[_constants.ENTRY] = entries;

    return result;
}